import { TableCell, TableRow, alpha, styled } from '@mui/material';

// Create styled components for consistent dark mode styling
export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#2c2c2c !important' : '#f5f5f5 !important',
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.mode === 'dark' ? '#3c3c3c !important' : '#e0e0e0 !important',
  },
  '&:hover': {
    backgroundColor: `${alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.1 : 0.05)} !important`,
  },
  '& .MuiTableCell-root': {
    color: theme.palette.text.primary,
    borderColor: theme.palette.divider,
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(1),
  borderColor: theme.palette.divider,
}));

// Update sxSwitch to use theme colors
export const sxSwitch = (num: number, theme: any) => {
  return {
    backgroundColor:
      num > 0
        ? theme.palette.mode === 'dark'
          ? alpha(theme.palette.warning.main, 0.15)
          : alpha(theme.palette.warning.light, 0.2)
        : theme.palette.mode === 'dark'
          ? alpha(theme.palette.action.disabled, 0.1)
          : alpha(theme.palette.action.disabled, 0.1),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius + 'px',
    '& input': {
      color: theme.palette.text.primary,
    },
  };
};
